import React, { useState } from "react";
import { AccountingTable } from "../../components/table/AccountingTable";
import { InvoiceList } from "../../components/table/InvoiceList";

export const AccountingPage: React.FC = () => {

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="flex flex-col gap-12 w-full mx-auto p-6">
      <section>
        <h1 className="text-3xl mb-4">Neue Rechnung hochladen oder manuell anlegen</h1>
        <AccountingTable onSuccess={handleRefresh}/>
      </section>

      <section>
        <h1 className="text-3xl mb-4">Gespeicherte Rechnungen bearbeiten & exportieren</h1>
        <InvoiceList refreshTrigger={refreshTrigger}/>
      </section>
    </div>
  );
};
